import isEmpty from 'lodash/isEmpty';

export function generateJoinString(arr) {
  return !isEmpty(arr) && arr.join(', ');
}

export function generateFrequencyString(frequency, dayOfWeek, dayOfMonth) {
  let formatted = `${frequency}`;

  if (dayOfWeek) {
    formatted += ` on ${dayOfWeek}`;
  }

  if (dayOfMonth) {
    formatted += ` on the ${dayOfMonth}`;
  }

  return formatted;
}
